// extracted by mini-css-extract-plugin
module.exports = {"directDepositCard":"DirectDepositInfo_directDepositCard__d8vEd","directDepositText":"DirectDepositInfo_directDepositText__c4dRj"};